import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';

@Component({
  selector: 'app-license-management',
  standalone: true,
  imports: [
    CommonModule, 
    MatCardModule, 
    MatButtonModule, 
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule
  ],
  template: `
    <div class="license-management-container">
      <mat-card class="main-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon class="title-icon">assignment</mat-icon>
            License Management
          </mat-card-title>
          <mat-card-subtitle>
            Comprehensive fishing license and permit management
          </mat-card-subtitle>
        </mat-card-header>
        
        <mat-card-content>
          <p class="description">
            Manage fishing licenses, permits, and regulatory compliance. Track license applications, 
            renewals, and violations. Ensure proper documentation and regulatory adherence for 
            all fishing activities.
          </p>
          
          <div class="license-grid">
            <div class="license-item">
              <mat-icon class="license-icon">description</mat-icon>
              <h3>License Applications</h3>
              <p>Process and track license applications</p>
            </div>
            
            <div class="license-item">
              <mat-icon class="license-icon">schedule</mat-icon>
              <h3>Renewals</h3>
              <p>Manage license renewals and expirations</p>
            </div>
            
            <div class="license-item">
              <mat-icon class="license-icon">warning</mat-icon>
              <h3>Compliance</h3>
              <p>Monitor violations and compliance status</p>
            </div>
          </div>
        </mat-card-content>
        
        <mat-card-actions>
          <button mat-raised-button color="primary">
            <mat-icon>assignment</mat-icon>
            View Licenses
          </button>
          <button mat-button>
            <mat-icon>add</mat-icon>
            New Application
          </button>
          <button mat-button>
            <mat-icon>schedule</mat-icon>
            Renewals
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  `,
  styles: [`
    .license-management-container {
      padding: 2rem;
      max-width: 1200px;
      margin: 0 auto;
    }
    
    .main-card {
      margin-bottom: 2rem;
    }
    
    .title-icon {
      margin-right: 8px;
      color: #1976d2;
    }
    
    .description {
      color: #666;
      line-height: 1.6;
      margin-bottom: 2rem;
    }
    
    .license-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 1.5rem;
      margin-bottom: 2rem;
    }
    
    .license-item {
      text-align: center;
      padding: 1rem;
      border-radius: 8px;
      background: #f8f9fa;
      transition: transform 0.2s;
    }
    
    .license-item:hover {
      transform: translateY(-2px);
    }
    
    .license-icon {
      font-size: 2rem;
      width: 2rem;
      height: 2rem;
      color: #1976d2;
      margin-bottom: 0.5rem;
    }
    
    .license-item h3 {
      margin: 0.5rem 0;
      color: #333;
      font-size: 1.1rem;
    }
    
    .license-item p {
      margin: 0;
      color: #666;
      font-size: 0.9rem;
    }
    
    mat-card-actions {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
    }
    
    mat-card-actions button {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    
    @media (max-width: 768px) {
      .license-management-container {
        padding: 1rem;
      }
      
      .license-grid {
        grid-template-columns: 1fr;
      }
      
      mat-card-actions {
        flex-direction: column;
      }
    }
  `]
})
export class LicenseManagementComponent {
  constructor() {}
} 